import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_time_picker = _resolveComponent("van-time-picker");
  const _component_van_picker_group = _resolveComponent("van-picker-group");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.show = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker_group, {
      tabs: ['选择日期', '选择时间'],
      onConfirm: $options.onConfirm,
      onCancel: $options.onCancel
    }, {
      default: _withCtx(() => [_createVNode(_component_van_date_picker, {
        modelValue: $data.currentDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.currentDate = $event),
        "min-date": $options.minDate,
        "max-date": $options.maxDate
      }, null, 8, ["modelValue", "min-date", "max-date"]), _createVNode(_component_van_time_picker, {
        modelValue: $data.currentTime,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.currentTime = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["onConfirm", "onCancel"])]),
    _: 1
  }, 8, ["show"]);
}